import HeroSection from "../HeroSection";
import FoundationSection from "../FoundationSection";
import ProblemSection from "../ProblemSection";
import SolutionSection from "../SolutionSection";
import IntegrationsSection from "../IntegrationsSection";
import DayTimelineSection from "../DayTimelineSection";
import ModalitiesSection from "../ModalitiesSection";
import TestimonialsSection from "../TestimonialsSection";
import CTASection from "../CTASection";
import "./styles.css";

const Index = () => {
  return (
    <div className="main-landing-page min-h-screen bg-background">
      <HeroSection />
      <FoundationSection />
      <SolutionSection />
      <IntegrationsSection />
      <DayTimelineSection />
      <ModalitiesSection />
      <ProblemSection />
      <TestimonialsSection />
      <CTASection />
    </div>
  );
};

export default Index;
